import { PERMISSIONS } from '../../../constants'
import { LineItem } from '../../../models/line-item'
import { useUserPermission } from '../../../ng-compat/hooks'

export const useLineItemBreakdownEligibility = (lineItem: LineItem) => {
  const hasPermission = useUserPermission(
    PERMISSIONS.PRODUCT_PACKAGING_BREAKDOWN_AT_SALE
  )

  const hasValidPackagingRelationship =
    lineItem.product.packaging.made_from.length === 1

  return {
    canShowBreakdownOption: hasPermission && hasValidPackagingRelationship,
  }
}
